// components/Events/PhantomHitEvent.tsx

import React, { useContext } from 'react';
import './PhantomHitEvent.css';
import { GameLog } from '../../../../Logs/LogsDisplay';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { getUniversalSourceIcon } from './StatChangeEvent';

interface PhantomHitEventProps {
  log: GameLog;
}

const PhantomHitEvent: React.FC<PhantomHitEventProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);

  const details = log.details;
  const sourceName = details.source || 'Phantom Hit';

  // Use the universal image fetching function
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: 'Item', // Phantom Hit is typically from items like Guinsoo's Rageblade
      imageState: log.imageState || "Guinsoo's Rageblade",
      sourceName: sourceName,
      championName: details.championName,
    },
    gameWideAssets,
    championsAssets
  );

  return (
    <div className="phantom-hit-event">
      {sourceIcon}
    </div>
  );
};

export default PhantomHitEvent;
